module.exports = __webpack_public_path__ + "img/cqxn.3f8de0da.png";